// feat/buyer-confirm-dialog (2026-05-24) — 커스텀 confirm 다이얼로그 (window.confirm 대체).
//
// 사용:
//   import { confirm } from './ConfirmDialog';
//   var ok = await confirm({ message: '진짜 삭제?', variant: 'danger' });
//   if (ok) { ... }
//
// 옵션:
//   message       — 본문 (필수)
//   title         — 헤더 (선택, 기본 없음)
//   confirmLabel  — 확인 버튼 (선택, 기본 t('commonConfirm'))
//   cancelLabel   — 취소 버튼 (선택, 기본 t('commonCancel'))
//   variant       — 'default' | 'danger' (선택, danger 시 확인 버튼 빨강)
//
// 인프라:
//   - window.dispatchEvent('autodex-buyer-confirm', { opts, resolve })
//   - ConfirmHost 가 event 받아서 modal 렌더 + resolve 호출 (Promise 해소)
//   - Layout 에 ConfirmHost 1회 mount (ToastHost 와 동일 패턴)

import React, { useState, useEffect } from 'react';
import { useT } from '../../i18n/I18nProvider';

var EVENT_NAME = 'autodex-buyer-confirm';

export function confirm(opts) {
  return new Promise(function(resolve) {
    try {
      window.dispatchEvent(new CustomEvent(EVENT_NAME, {
        detail: { opts: opts || {}, resolve: resolve },
      }));
    } catch (e) {
      // SSR/no-window 폴백 — 즉시 false (사용자 액션 부재로 간주)
      resolve(false);
    }
  });
}

export function ConfirmHost() {
  var t = useT();
  var [state, setState] = useState(null);
  // state = { opts, resolve } 또는 null

  useEffect(function() {
    function onConfirm(e) {
      var d = e.detail || {};
      // 이미 열려 있는 경우 — 이전 resolve(false) 후 새 다이얼로그 표시
      setState(function(prev) {
        if (prev && prev.resolve) { try { prev.resolve(false); } catch (_) {} }
        return { opts: d.opts || {}, resolve: d.resolve };
      });
    }
    function onKey(e) {
      if (e.key === 'Escape') resolveAndClose(false);
    }
    window.addEventListener(EVENT_NAME, onConfirm);
    window.addEventListener('keydown', onKey);
    return function() {
      window.removeEventListener(EVENT_NAME, onConfirm);
      window.removeEventListener('keydown', onKey);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function resolveAndClose(value) {
    setState(function(prev) {
      if (prev && prev.resolve) { try { prev.resolve(value); } catch (_) {} }
      return null;
    });
  }

  if (!state) return null;

  var opts = state.opts || {};
  var isDanger = opts.variant === 'danger';
  var confirmLabel = opts.confirmLabel || t('commonConfirm');
  var cancelLabel = opts.cancelLabel || t('commonCancel');

  return (
    <div onClick={function(){ resolveAndClose(false); }}
      style={{
        position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
        background: 'rgba(15,23,42,0.55)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        zIndex: 1500, padding: 16,
      }}>
      <div onClick={function(e){ e.stopPropagation(); }}
        style={{
          width: '100%', maxWidth: 400,
          background: 'white', borderRadius: 14,
          padding: '22px 22px 18px',
          boxShadow: '0 16px 40px rgba(15,23,42,0.2)',
        }}>
        {opts.title && (
          <div style={{ fontSize: 16, fontWeight: 800, color: '#0f172a', marginBottom: 8 }}>
            {opts.title}
          </div>
        )}
        <div style={{ fontSize: 13, color: '#334155', lineHeight: 1.55, marginBottom: 18, whiteSpace: 'pre-wrap' }}>
          {opts.message || ''}
        </div>
        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
          <button type="button" autoFocus onClick={function(){ resolveAndClose(false); }}
            style={{
              padding: '9px 16px', border: '1px solid #cbd5e1', borderRadius: 8,
              background: 'white', color: '#475569', fontSize: 13, fontWeight: 700,
              cursor: 'pointer',
            }}>
            {cancelLabel}
          </button>
          <button type="button" onClick={function(){ resolveAndClose(true); }}
            style={{
              padding: '9px 18px', border: 'none', borderRadius: 8,
              background: isDanger ? '#dc2626' : 'linear-gradient(135deg, #1B3A5C 0%, #3b82f6 100%)',
              color: 'white', fontSize: 13, fontWeight: 800,
              cursor: 'pointer',
              boxShadow: '0 4px 10px rgba(15,23,42,0.18)',
            }}>
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}

export default ConfirmHost;
